/** Customer intake form — declarative local state + validation (no external invoke). */

export const intakeCanvas = {
  schema_version: 1,
  page_id: 'tenantabc/customer-intake',
  tenant_id: 'tenantabc',
  title: 'Customer Intake',
  visibility: { policy: 'private' },
  dataset_slots: [],
  state: {
    form: {
      type: 'object',
      default: { name: '', email: '', notes: '' },
    },
    submitted: { type: 'boolean', default: false },
  },
  validation_schemas: {
    intakeFormSchema: {
      required: ['form.name', 'form.email'],
      properties: {
        'form.email': { format: 'email' },
      },
    },
  },
  root: {
    id: 'root',
    component: 'builtin:Stack',
    version: '1.0.0',
    props: { spacing: 2 },
    children: [
      {
        id: 'heading',
        component: 'builtin:Typography',
        version: '1.0.0',
        props: { variant: 'h5', text: 'Customer Intake' },
      },
      {
        id: 'form',
        component: 'builtin:Form',
        version: '1.0.0',
        props: {},
        events: {
          onSubmit: [
            { action: 'validateState', schemaRef: 'intakeFormSchema' },
            { action: 'setState', path: 'submitted', value: true },
          ],
        },
        children: [
          {
            id: 'name',
            component: 'builtin:TextField',
            version: '1.0.0',
            props: {
              label: 'Full name',
              name: 'form.name',
              required: true,
              statePath: 'form.name',
              variant: 'outlined',
            },
            events: {
              onChange: [{ action: 'setState', path: 'form.name', from: 'event.value' }],
            },
          },
          {
            id: 'email',
            component: 'builtin:TextField',
            version: '1.0.0',
            props: {
              label: 'Email',
              name: 'form.email',
              required: true,
              statePath: 'form.email',
              variant: 'outlined',
            },
            events: {
              onChange: [{ action: 'setState', path: 'form.email', from: 'event.value' }],
            },
          },
          {
            id: 'notes',
            component: 'builtin:TextField',
            version: '1.0.0',
            props: {
              label: 'Notes',
              name: 'form.notes',
              statePath: 'form.notes',
              variant: 'outlined',
              multiline: true,
              rows: 3,
            },
            events: {
              onChange: [{ action: 'setState', path: 'form.notes', from: 'event.value' }],
            },
          },
          {
            id: 'submit',
            component: 'builtin:Button',
            version: '1.0.0',
            props: { label: 'Submit', type: 'submit', variant: 'contained' },
          },
        ],
      },
    ],
  },
};

export const intakeManifest = {
  manifest_id: 'man_intake_1',
  page_id: 'tenantabc/customer-intake',
  tenant_id: 'tenantabc',
  canvas_version: 1,
  mode: 'latest_validated',
  entries: [],
};
